import {
  GET_PMCS,
  GET_WEB_BASIC,
  GET_WEB_DETAILED,
  SET_ONLINE_SALES_FILTERS
} from '../constants/onlineSales';

const DEFAULT_STATE = {
  kpis: [],
  feed: [],
  prices: [],
  history: [],
  references: [],
  store_references: [],
  pmcs: [],
  dn_history: [],
  price_history: [],
  pmc_choices: {},
  stateFilters: {
    wine: null,
    market: null,
    date: null
  }
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case GET_WEB_BASIC:
      return { ...state, ...action.payload };
    case GET_WEB_DETAILED:
      return { ...state, ...action.payload };

    case GET_PMCS:
      return { ...state, pmcs: action.payload };

    case SET_ONLINE_SALES_FILTERS:
      return {
        ...state,
        stateFilters: { ...state.stateFilters, ...action.payload }
      };
    default:
      return state;
  }
};
